import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { GlobalService } from '../services/global.service';

@Pipe({
    name: 'pageCount',
    standalone: false
})
export class PageCountPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer, private _gS: GlobalService) { }

	transform(value: any, plain = false, part?): any {

		if (!value) return '--';

		let roundedValue = this._gS.roundPagesFraction(value);
		var a = Math.floor(roundedValue);
		var b = (roundedValue - a) * 8;

		if (part) {
			return part == 'whole' ? a.toString() : b.toString() + '/8';
		}

		if (!plain) {
			let page_count = `${a.toString()}&nbsp;&nbsp;&nbsp;${b.toString()}/8`;
			return this.sanitizer.sanitize(SecurityContext.HTML, page_count);
		} else {
			let page_count = `${a.toString()} ${b.toString()}/8`;
			return page_count;
		}


	}

}
